import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const PropertyTypeTabsTitle = styled.h2`
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 16px;
  line-height: 28px;
  @media (${mediaQuery.mobile}) {
    font-size: 20px;
    line-height: 26px;
  }
`;

export const PropertyTypeTabList = styled.div`
  margin-top: 16px;
  display: grid;
  column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr;
  list-style-type: none;

  @media (${mediaQuery.mobile}) {
    grid-template-columns: 1fr;
  }
`;
